import Column from '@components/Column';
import Text from '@components/Text';

import styles from './styles.module.scss';

interface Props {
    color?: string;
    size?: 'full' | 'small';
}

function Loading({ color, size = 'full' }:Props) {
  if (size === 'small') {
    return (
            <Column align='center'
                    fullWidth
                    className={styles.small}>
                <span className={styles.loader}/>
            </Column>
    );
  }
  return (<Column align='center' justify='center'
                  spacing={16}
                  fullWidth fullHeight>
      <span className={styles.loader}/>
      <Text fontWeight='medium' color={color}>잠시만 기다려주세요.</Text>
  </Column>);
}

export default Loading;
